import { useEffect, useState } from "react";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useTenantChallenges } from "./useTenantChallenges";
import { Challenge } from "@/models/database/challenges/challenge.model";

export const useChallengesBySlugs = (slugs: string[], status: string) => {
  const {
    data: allChallenges,
    loading,
    error,
  } = useTenantChallenges(brand.tenantId, status);
  const [filteredChallenges, setFilteredChallenges] = useState<Challenge[]>([]);

  useEffect(() => {
    if (allChallenges && slugs.length > 0) {
      const matchedChallenges = allChallenges.filter((news) =>
        slugs.includes(news.slug)
      );
      setFilteredChallenges(matchedChallenges);
    }
  }, [allChallenges, slugs]);

  return {
    data: filteredChallenges,
    loading,
    error,
  };
};
